import React, { Fragment } from 'react';
import { withHousehold } from 'Context/HouseholdContext';
import { goalsObjectivesAndInterestsHref } from 'Consts/advisorUris';
import { goalsObjectivesAndInterestsHref as clientGoalsObjectivesAndInterestsHref } from 'Consts/clientUris';
import PropTypes from 'prop-types';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import AddMoreInfoButton from 'Components/UI/AddMoreInfoButton';
import { getOptions } from 'Helpers/Meta';
import { currency } from 'Helpers/Formats';
import './Goals.css';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import featureEnabled from 'Helpers/Affordances';
import relationships from 'facet-rest/src/consts/relationships';
import Moment from 'moment';

const convertGoalsToStringArray = (goals, goalsFeatureEnabled) => goals.map((goal) => {
  const {
    name,
    description,
    amount,
    timeHorizonValue,
    endDate,
  } = goal.attributes;
  const typePrompt = getOptions(goal.meta.template, 'type').find(
    item => item.id === goal.attributes.type,
  ).value;

  //  This can be null due to migrated old goals having no values set here.
  const timeHorizonTypeOption = getOptions(
    goal.meta.template,
    'timeHorizonType',
  ).find(item => item.id === goal.attributes.timeHorizonType);

  let timeHorizon = '';
  if (timeHorizonTypeOption && endDate !== '') {
    const endDateTimestamp = new Moment(endDate).format('L');
    timeHorizon = goalsFeatureEnabled ? ` - ${endDateTimestamp}` : ` - ${timeHorizonValue} ${timeHorizonTypeOption.value}`;
  }

  let result = name
    ? `${name} (${typePrompt})`
    : `${typePrompt}`;

  if (description && description !== '') {
    result += ` - ${description}`;
  }
  result += ` - ${currency(Number(amount), true)}${timeHorizon}`;
  return result;
});

function Goals({ financialGoals, householdId, isAgent }) {
  const { householdResource } = useSimpleHousehold();
  const goalFeatureEnabled = featureEnabled(householdResource, relationships.goalsPageAndBanner.name);
  function renderGoalHeader(icon, iconSize, title) {
    return (
      <div className="goal-header">
        <FontAwesome icon={icon} fontSize={iconSize} />
        <h4>{title}</h4>
      </div>
    );
  }

  function renderGoals(goals) {
    return goals.map((goal, index) => {
      return (
        <div className="goal" key={goal}>
          <div className="goal-number">{index + 1}</div>
          <RichTextDisplay className="goal-text" content={goal} />
        </div>);
    });
  }

  let hasGoalsAndOrConcerns = false;
  if (financialGoals && financialGoals.length > 0) {
    hasGoalsAndOrConcerns = true;
  }

  return (
    <div className="goals">
      {hasGoalsAndOrConcerns ? (
        <Fragment>
          <div className="financial-goals">
            {financialGoals
              && financialGoals.length > 0
              && renderGoalHeader(
                'bar-chart',
                '20px',
                'Financial goals and aspirations',
              )}
            <div className="content">
              {financialGoals
                && financialGoals.length > 0
                && renderGoals(convertGoalsToStringArray(financialGoals, goalFeatureEnabled))}
            </div>
          </div>
        </Fragment>
      ) : (
        <AddMoreInfoButton
          buttonText="Click here to add goals"
          href={
            isAgent
              ? goalsObjectivesAndInterestsHref(householdId)
              : clientGoalsObjectivesAndInterestsHref
          }
        />
      )}
    </div>
  );
}

Goals.propTypes = {
  financialGoals: PropTypes.arrayOf(PropTypes.object),
  householdId: PropTypes.number,
  isAgent: PropTypes.bool,
};

Goals.defaultProps = {
  financialGoals: [],
  householdId: -1,
  isAgent: false,
};

export default withHousehold(Goals);
